import React, { useState, useEffect } from 'react';

import { createAPIEndpoint } from '../api/index'
import { getConfiguration, ENDPOINTS } from '../api/config'

import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from 'react-bootstrap/Modal';
import Plantilla from './plantillas/Plantilla'

import Spinner from './Spinner';
import ErrorModal, { useErrorHandling } from './ErrorModal';
import { ContinuarMasTardeButton } from './ContinuarMasTardeButton';
import Form from 'react-bootstrap/Form';
import Badge from 'react-bootstrap/Badge';
import SeleccionHorarioOk from './SeleccionHorarioOk';

import { setProgress } from './Progreso';
import { CountdownTimer } from './CountdownTimer';
import useValidadorTipoCurso from './useValidadorTipoCurso';
import ofertaAcademicaClass from './classes/ofertaAcademica'


const SeleccionHorario = (props) => {
    useEffect(() => {
        setProgress(75, 'Confirmación de horario');
    }, []);

    //const handleOnContinuar = () => { props.onSiguiente(); };
    const [selectedKey, setSelectedKey] = useState(null);
    const handleChangeSelectedKey = (key) => setSelectedKey(selectedKey === key ? null : key);

    const [terminosAceptados, setTerminosAceptados] = useState(false);
    const handleChkAceptoTerminosChanged = (value) => { setTerminosAceptados(value) };

    //const [ofertaAcademica, setOfertaAcademica] = useState(null);
    const [materiasSeleccionadas, setMateriasSeleccionadas] = useState([]);
    const [materiasAlternativas, setMateriasAlternativas] = useState([]);

    const [planRigido, setPlanRigido] = useState(false);

    const maximosobrecarga = props.planAcademico?.maximossobrecarga?.maximosobrecargatotal ?? 0;
    const maximosobrecargasession = props.planAcademico?.maximossobrecarga?.maximosobrecargasession || [];

    const [materiaPendienteSobrecarga, setMateriaPendienteSobrecarga] = useState(null);
    const [mostrarCatalogoSobrecarga, setMostrarCatalogoSobrecarga] = useState(false);
    const [materiaBloqueadaMinimo, setMateriaBloqueadaMinimo] = useState(null);
    const [sesionesPendientesReemplazo, setSesionesPendientesReemplazo] = useState([]);

    const minimaCargaRequerida = props.planAcademico?.cargaminima ?? 0;
    const minimoDePaquete = props.planAcademico?.minimopaquete ?? 0;
    const maximoDePaquete = props.planAcademico?.maximopaquete ?? 0;

    const tipomodeloaliat = props.planAcademico?.tipomodeloaliat;
    const tipoplanacademico = props.planAcademico?.tipoplanacademico || '';

    const getMaximoMateriasSesion = (numsession) => {
        const sesion = String(numsession);
        if (Number(tipomodeloaliat) === 30) {
            if (sesion === '5') return 3;
            if (sesion === '3') return 4;
            return Number.POSITIVE_INFINITY;
        }
        if (tipoplanacademico.startsWith('MFL')) {
            if (sesion === '5') return 4;
            if (sesion === '6') return 3;
            return Number.POSITIVE_INFINITY;
        }
        return Number.POSITIVE_INFINITY;
    };

    const getMaximoSobrecargaSesion = (numsession) => {
        const cfg = maximosobrecargasession.find(x => String(x.numsession) === String(numsession));
        return cfg?.maximosobrecarga ?? 0;
    };

    const ordenarMateriasConSobrecargaAlFinal = (materias) => {
        return [...materias].sort((a, b) => {
            const aExtra = a.esExtra && !a.deleted ? 1 : 0;
            const bExtra = b.esExtra && !b.deleted ? 1 : 0;
            if (aExtra !== bExtra) return aExtra - bExtra;
            return (a.index ?? 0) - (b.index ?? 0);
        });
    };

    const contarMateriasPaqueteSesion = (materias, numsession) =>
        materias.filter(x => !x.deleted && !x.esExtra && String(x.numsession) === String(numsession)).length;

    const contarMateriasSobrecargaSesion = (materias, numsession) =>
        materias.filter(x => !x.deleted && x.esExtra && String(x.numsession) === String(numsession)).length;

    const materiasActivasActuales = materiasSeleccionadas.filter(x => !x.deleted).length;
    const materiasPaqueteActuales = materiasSeleccionadas.filter(x => !x.deleted && !x.esExtra).length;
    const materiasExtraActuales = materiasSeleccionadas.filter(m => m.esExtra && !m.deleted).length;

    const puedeAgregarComoPaquete = (mat, seleccionadas = materiasSeleccionadas) => {
        const paqueteActual = seleccionadas.filter(x => !x.deleted && !x.esExtra).length;
        if (paqueteActual >= maximoDePaquete) return false;
        return contarMateriasPaqueteSesion(seleccionadas, mat.numsession) < getMaximoMateriasSesion(mat.numsession);
    };

    const puedeAgregarComoSobrecarga = (mat, seleccionadas = materiasSeleccionadas) => {
        const extrasActuales = seleccionadas.filter(x => !x.deleted && x.esExtra).length;
        if (extrasActuales >= maximosobrecarga) return false;
        return contarMateriasSobrecargaSesion(seleccionadas, mat.numsession) < getMaximoSobrecargaSesion(mat.numsession);
    };

    const cargaMinimaInsuficiente = materiasActivasActuales < minimaCargaRequerida;
    const aplicaCostoIndividual = materiasActivasActuales < minimoDePaquete && materiasActivasActuales >= minimaCargaRequerida;

    const horarioConflicto = materiasSeleccionadas.some(x => x.esEmpalmada);
    const ejecutarAgregarMateria = (materiaDest, esSobrecargaAcad) => {
        let seleccionadas = [...materiasSeleccionadas];
        let nuevaMateria = { 
            ...materiaDest, 
            esExtra: esSobrecargaAcad, 
            cambiada: true, 
            esEmpalmada: false, 
            index: seleccionadas.length + 100 
        };
        seleccionadas.push(nuevaMateria);
        seleccionadas = ordenarMateriasConSobrecargaAlFinal(seleccionadas);
        let alternativas = materiasAlternativas.filter(x => x.id !== materiaDest.id);
        
        validarEmpalmes(seleccionadas);
        setMateriasSeleccionadas(seleccionadas);
        setMateriasAlternativas(alternativas);

        if (!esSobrecargaAcad) {
            setSesionesPendientesReemplazo(prev => {
                const idx = prev.findIndex(s => String(s) === String(materiaDest.numsession));
                if (idx === -1) return prev;
                return [...prev.slice(0, idx), ...prev.slice(idx + 1)];
            });
        }
        
        setMateriaPendienteSobrecarga(null);
        setMostrarCatalogoSobrecarga(false); 
    };

    const confirmarAgregarSobrecarga = (materiaDest) => {
        ejecutarAgregarMateria(materiaDest, true);
    };

    const handleIntentarAgregarMateria = (mat) => {
        if (puedeAgregarComoPaquete(mat)) {
            ejecutarAgregarMateria(mat, false);
        } else if (puedeAgregarComoSobrecarga(mat)) {
            setMateriaPendienteSobrecarga(mat);
        }
    };

    const cargarPropuestaOriginal = () => {
        let oferta = new ofertaAcademicaClass(props.planAcademico);
        validarEmpalmes(oferta.materiasSugeridas);
        setMateriasSeleccionadas(ordenarMateriasConSobrecargaAlFinal(oferta.materiasSugeridas));
        setMateriasAlternativas(oferta.materiasAlternativas);
        setSesionesPendientesReemplazo([]);
        setSelectedKey(null);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        cargarPropuestaOriginal();
    }, [props.planAcademico])

    const handleChangeMateria = (origId, destId) => {
        let materiaOrig = materiasSeleccionadas.filter(x => x.id === origId)[0];
        let materiaDest = materiasAlternativas.filter(x => x.id === destId)[0];

        let seleccionadas = materiasSeleccionadas.filter(x => x.id !== origId);
        let alternativas = materiasAlternativas.filter(x => x.id !== destId);
        if (!materiaDest.deleted) seleccionadas.push(materiaDest);
        if (!materiaOrig.deleted) alternativas.push(materiaOrig);

        let origIndex = materiaOrig.index;
        materiaOrig.index = materiaDest.index;
        materiaDest.index = origIndex;
        materiaOrig.cambiada = true;
        materiaDest.cambiada = true;
        materiaOrig.esEmpalmada = false;
        materiaDest.esEmpalmada = false;

        materiaDest.esExtra = materiaOrig.esExtra;
        materiaOrig.esExtra = false; 

        seleccionadas = ordenarMateriasConSobrecargaAlFinal(seleccionadas);
        alternativas = alternativas.sort((a, b) => { return a.index - b.index; });

        validarEmpalmes(seleccionadas);

        setMateriasSeleccionadas(seleccionadas);
        setMateriasAlternativas(alternativas);
        setSelectedKey(null);
    };

    const handleBorrarMateria = (materiaId) => {
        let materiaALiminar = materiasSeleccionadas.find(x => x.id === materiaId);
        if (!materiaALiminar) return;

        let eraSobrecarga = materiaALiminar.esExtra; 

        if (!eraSobrecarga) {
            const minimoscarga = props.planAcademico?.minimoscarga || [];
            const reqMinimo = minimoscarga.find(x => String(x.numsession) === String(materiaALiminar.numsession))?.minimocarga ?? 0;
            const materiasSesionActuales = materiasSeleccionadas.filter(x => String(x.numsession) === String(materiaALiminar.numsession) && !x.deleted && !x.esExtra).length;

            if (materiasSesionActuales <= reqMinimo) {
                setMateriaBloqueadaMinimo(materiaALiminar);
                return;
            }
        }

        let seleccionadas = materiasSeleccionadas.filter(x => x.id !== materiaId);

        let materiaParaAlternativas = { 
            ...materiaALiminar, 
            esExtra: false, 
            esEmpalmada: false,
            cambiada: true 
        };

        let alternativas = materiasAlternativas.filter(x => x.id !== materiaId);
        alternativas.push(materiaParaAlternativas);

        if (!eraSobrecarga) {
            let materiaSobrecargaMismaSesion = seleccionadas.find(x =>
                x.esExtra &&
                !x.deleted &&
                String(x.numsession) === String(materiaALiminar.numsession) &&
                contarMateriasPaqueteSesion(seleccionadas, x.numsession) < getMaximoMateriasSesion(x.numsession)
            );

            if (materiaSobrecargaMismaSesion) {
                materiaSobrecargaMismaSesion.esExtra = false;
            } else {
                setSesionesPendientesReemplazo(prev => [...prev, String(materiaALiminar.numsession)]);
            }
        }

        seleccionadas = ordenarMateriasConSobrecargaAlFinal(seleccionadas);
        alternativas = alternativas.sort((a, b) => a.index - b.index);

        validarEmpalmes(seleccionadas);

        setMateriasSeleccionadas([...seleccionadas]);
        setMateriasAlternativas([...alternativas]);
        setSelectedKey(null);
    };

    const sesionesPermitidasAgregar = [...new Set(sesionesPendientesReemplazo.map(String))];

    const materiasCandidatasCatalogo = materiasAlternativas
        .filter(x => !materiasSeleccionadas.some(s => s.idmateria === x.idmateria && !s.deleted))
        .filter(x => sesionesPermitidasAgregar.length === 0 || sesionesPermitidasAgregar.includes(String(x.numsession)));

    const hayCupoPaqueteDisponible = materiasPaqueteActuales < maximoDePaquete &&
        materiasCandidatasCatalogo.some(mat => puedeAgregarComoPaquete(mat));

    const hayCupoSobrecargaDisponible = materiasExtraActuales < maximosobrecarga &&
        materiasCandidatasCatalogo.some(mat => puedeAgregarComoSobrecarga(mat));

    // Si el paquete aún no está completo pero no hay materias válidas de paquete (p.ej. tope por sesión),
    // el botón debe mostrarse como sobrecarga.
    const debeAgregarComoSobrecarga = !hayCupoPaqueteDisponible && hayCupoSobrecargaDisponible;
    const puedeAgregarMaterias = hayCupoPaqueteDisponible || hayCupoSobrecargaDisponible;

    const materiasDisponiblesParaAgregar = materiasCandidatasCatalogo.filter(mat => {
        if (hayCupoPaqueteDisponible) return puedeAgregarComoPaquete(mat);
        return puedeAgregarComoSobrecarga(mat);
    });

    const validarEmpalmes = (materias) => {
        if (!materias || !materias.length) return;

        materias.forEach(m => {
            m.esEmpalmada = false;
        });

        let data = JSON.parse(JSON.stringify(materias));
        data = data.filter(x => !x.esVirtual && !x.deleted);

        const MAPA_DIAS_SEMANA = { 'D': 0, 'L': 1, 'M': 2, 'MI': 3, 'J': 4, 'V': 5, 'S': 6 };

        const obtenerDiasNumericos = (diasString) => {
            if (!diasString || typeof diasString !== "string") return [];
            return diasString.split(',').map(d => MAPA_DIAS_SEMANA[d.trim().toUpperCase()]).filter(d => d !== undefined);
        };

        const crearFechaSeguro = (valorFecha) => {
            if (!valorFecha) return null;
            const fecha = new Date(valorFecha + "T00:00:00");
            return Number.isNaN(fecha.getTime()) ? null : fecha;
        };

        const fechaInicioDe = (materia, horario) =>
            crearFechaSeguro(horario?.fechainicial) ?? crearFechaSeguro(materia?.fechainicial);
        const fechaFinDe = (materia, horario) =>
            crearFechaSeguro(horario?.fechafinal) ?? crearFechaSeguro(materia?.fechafinal);

        const obtenerRangoComunFechas = (inicio1, fin1, inicio2, fin2) => {
            if (!inicio1 || !fin1 || !inicio2 || !fin2) return null;

            const maxInicio = inicio1 > inicio2 ? inicio1 : inicio2;
            const minFin = fin1 < fin2 ? fin1 : fin2;
            return maxInicio <= minFin ? { inicio: maxInicio, fin: minFin } : null;
        };

        const seTraslapanHoras = (hInicio1, hFin1, hInicio2, hFin2) => {
            if (!hInicio1 || !hFin1 || !hInicio2 || !hFin2) return false;
            return hInicio1 < hFin2 && hInicio2 < hFin1;
        };

        for (let i = 0; i < data.length; i++) {
            const m1 = data[i];

            for (let j = i + 1; j < data.length; j++) {
                const m2 = data[j];
                let hayEmpalmeReal = false;

                if (Array.isArray(m1.horario) && Array.isArray(m2.horario)) {
                    for (const h1 of m1.horario) {
                        for (const h2 of m2.horario) {
                            const rangoComun = obtenerRangoComunFechas(
                                fechaInicioDe(m1, h1),
                                fechaFinDe(m1, h1),
                                fechaInicioDe(m2, h2),
                                fechaFinDe(m2, h2)
                            );
                            if (!rangoComun) continue;

                            const diasM1 = obtenerDiasNumericos(h1?.dia);
                            const diasM2 = obtenerDiasNumericos(h2?.dia);
                            const diasCompartidos = diasM1.filter(dia => diasM2.includes(dia));

                            if (diasCompartidos.length > 0) {
                                if (seTraslapanHoras(h1?.horainicio, h1?.horafin, h2?.horainicio, h2?.horafin)) {
                                    
                                    // Verificar que el día de la semana compartido realmente exista en el calendario de ese traslape
                                    let diaDeClaseExisteEnTraslape = false;
                                    let fechaBucle = new Date(rangoComun.inicio);
                                    while (fechaBucle <= rangoComun.fin) {
                                        if (diasCompartidos.includes(fechaBucle.getDay())) {
                                            diaDeClaseExisteEnTraslape = true;
                                            break;
                                        }
                                        fechaBucle.setDate(fechaBucle.getDate() + 1);
                                    }

                                    if (diaDeClaseExisteEnTraslape) {
                                        hayEmpalmeReal = true;
                                        break;
                                    }
                                }
                            }
                        }
                        if (hayEmpalmeReal) break;
                    }
                }

                if (hayEmpalmeReal) {
                    m1.esEmpalmada = true;
                    m2.esEmpalmada = true;
                }
            }
        }

        materias.forEach(materiaOriginal => {
            const copiaProcesada = data.find(x => x.id === materiaOriginal.id);
            materiaOriginal.esEmpalmada = copiaProcesada ? copiaProcesada.esEmpalmada : false;
        });
    };

    const { conflictosTipoCurso } = useValidadorTipoCurso(materiasSeleccionadas);
    let cumpleTodo = !cargaMinimaInsuficiente && !horarioConflicto && terminosAceptados && !conflictosTipoCurso.length;

    const NotificacionesErrores = ({ conflicto, conflictosTipoCurso, insuficiente, costoIndividual }) => {
        let notified = false;
        let isConflict = conflicto;
        notified = notified || isConflict;

        let isConflictCourseType = false;
        let conflictoTipoCurso = null;
        if (conflictosTipoCurso && conflictosTipoCurso.length) {
            conflictoTipoCurso = conflictosTipoCurso[0];
            isConflictCourseType = !notified && conflictoTipoCurso && conflictoTipoCurso.total > conflictoTipoCurso.maximotipocurso;
            notified = notified || isConflictCourseType;
        }

        return (<>
            {insuficiente && (
                <div className="portal-alert bg-color-red">
                    <span className="material-icons">error</span>
                    <strong>No cumples con la carga mínima obligatoria. Por favor, selecciona al menos {minimaCargaRequerida} materias para continuar.</strong>
                </div>
            )}

            {costoIndividual && (
                <div className="portal-alert bg-color-orange">
                    <span className="material-icons">info</span>
                    <strong>¡Atención con tu plan de pagos! Has seleccionado menos de las {minimoDePaquete} materias requeridas para el beneficio del Costo por Paquete. Al procesar esta cantidad, tu colegiatura se calculará usando el costo por materia individual.</strong>
                </div>
            )}

            {isConflict && (
                <div className="portal-alert bg-color-orange">
                    <span className="material-icons">warning</span>
                    <strong>Tienes un conflicto en tu horario</strong>
                </div>
            )}

            {isConflictCourseType && (
                <div className="portal-alert bg-color-red">
                    <span className="material-icons">warning</span>
                    <strong>Hay un conflicto en tu horario. Solo puedes seleccionar {conflictoTipoCurso.maximotipocurso} de las materias indicadas.</strong>
                </div>
            )}
        </>);
    };


    const { error, clearError, showErrorModal } = useErrorHandling('PA004');
    const [showSpinner, setShowSpinner] = useState(false);


    //const [resultadoInscripcion, setResultadoInscripcion] = useState(null);
    //const testRes = JSON.parse('{"matricula":"00000360173","grado":"UGRD","numerodegrado":0,"institucion":"ETAC","cclinscripcion":"2541","ofertaacademica":[{"numclase":1202,"accioninscripcion":"OR","estado":"Correcto","estadodetalle":"Correcto","mensajes":[]},{"numclase":1208,"accioninscripcion":"OR","estado":"Correcto","estadodetalle":"Correcto","mensajes":[]},{"numclase":1222,"accioninscripcion":"OR","estado":"Correcto","estadodetalle":"Correcto","mensajes":[]},{"numclase":1227,"accioninscripcion":"OR","estado":"Correcto","estadodetalle":"Correcto","mensajes":[]},{"numclase":1239,"accioninscripcion":"OR","estado":"Correcto","estadodetalle":"Correcto","mensajes":[]}],"ofertaacademicaeliminada":null}')
    const testRes = null;
    const [resultadoInscripcion, setResultadoInscripcion] = useState(testRes);
    const [hayErroresInscripcion, setHayErroresInscripcion] = useState(null);
    const clearErroresInscripcion = () => setHayErroresInscripcion(null);

    const handleInscribirMaterias = () => {
        //setProgress(99, 'Inscripción finalizada');
        //setResultadoInscripcion(true);
        //return;
        setShowSpinner(true);

        let planAcademico = props.planAcademico;
        let ofertaAcademica = materiasSeleccionadas.map(x => {
            return {
                numclase: x.numclase,
                accioninscripcion: x.accioninscripcion,
                virtual: x.virtual
            }
        });

        const studentEnrollRequest = {
            matricula: planAcademico.matricula,
            grado: planAcademico.grado,
            numerodegrado: planAcademico.numerodegrado,
            institucion: planAcademico.institucion,
            cclinscripcion: planAcademico.cclinscripcion,
            campus: planAcademico.campus,
            ofertaacademica: ofertaAcademica,
        }

        createAPIEndpoint(ENDPOINTS.enroll)
            .post(studentEnrollRequest)
            .then(res => {
                if (!res || !res.data || res.data.length === 0) {
                    showErrorModal("Ocurrio un error al inscribir tu horario. Por favor intenta nuevamente.<br /><br />Si el problema persiste contacta al administrador del sistema", error.serie, '001');
                    return;
                }

                const resultado = res.data[0];
                const resultadoOfertaAcademica = resultado.ofertaacademica;
                if (resultadoOfertaAcademica.some(x => x.estado !== "Correcto")) {
                    setHayErroresInscripcion(true); //si hubo errores
                    return;
                }

                //No hubo errores
                setProgress(99, 'Inscripción finalizada');
                setResultadoInscripcion(resultado);
                return;
            })
            .catch((err) => {
                showErrorModal(null, error.serie, '002');
            }).finally(() => {
                setShowSpinner(false);
            });
    };

    let cantidadMateriasInscritas = props.planAcademico?.ofertainscrita?.length || 0;
    let hayMateriasCambiadas = materiasSeleccionadas.some(x => x.cambiada);
    let contadorMateriasSeleccionadas = materiasPaqueteActuales + cantidadMateriasInscritas;
    let cantidadCursosSugeridos = (props.planAcademico.maximopaquete || 0);

    const isPlanRigido = props.planAcademico?.tipoplanacademico?.startsWith('MR');

    useEffect(() => {
        if (isPlanRigido && props.planAcademico && !resultadoInscripcion) {

            setShowSpinner(true);

            const materiasRigidas = props.planAcademico.ofertaacademica.filter(x => x.sugerida === "Y");

            const ofertaParaInscribir = materiasRigidas.map(x => ({
                numclase: x.numclase,
                accioninscripcion: x.accioninscripcion,
                virtual: x.virtual
            }));

            const studentEnrollRequest = {
                matricula: props.planAcademico.matricula,
                grado: props.planAcademico.grado,
                numerodegrado: props.planAcademico.numerodegrado,
                institucion: props.planAcademico.institucion,
                cclinscripcion: props.planAcademico.cclinscripcion,
                campus: props.planAcademico.campus,
                ofertaacademica: ofertaParaInscribir,
            };

            createAPIEndpoint(ENDPOINTS.enroll)
                .post(studentEnrollRequest)
                .then(res => {
                    if (!res || !res.data || res.data.length === 0) {
                        showErrorModal("Error al inscribir tu horario automáticamente.", error.serie, '001');
                        return;
                    }

                    const resultado = res.data[0];
                    if (resultado.ofertaacademica.some(x => x.estado !== "Correcto")) {
                        setHayErroresInscripcion(true);
                        return;
                    }

                    setProgress(99, 'Inscripción finalizada');
                    setResultadoInscripcion(resultado);
                })
                .catch((err) => {
                    showErrorModal(null, error.serie, '002');
                }).finally(() => {
                    setShowSpinner(false);
                });
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.planAcademico]);

    if (!!resultadoInscripcion) {
        return (<SeleccionHorarioOk
            planAcademico={props.planAcademico}
            resultadoInscripcion={resultadoInscripcion}
            planRigido={planRigido} />)
    }

    return (<>
        <div className="container">
            <CountdownTimer />

            <Spinner show={showSpinner} />

            <ErrorModal error={error} onClose={clearError} />

            <ModalClaseSinCupo show={hayErroresInscripcion}
                onContinuarConHorario={() => clearErroresInscripcion()}
                onReestablecerPropuesta={() => { clearErroresInscripcion(); cargarPropuestaOriginal() }} />

            <NotificacionesErrores 
                insuficiente={cargaMinimaInsuficiente} 
                conflicto={horarioConflicto}
                conflictosTipoCurso={conflictosTipoCurso} 
                costoIndividual={aplicaCostoIndividual}
            />

            <Plantilla id="ApreciableEstudiante" planInfo={props.planAcademico} />

            <Plantilla id="SeleccionHorario"></Plantilla>

            <div className="contador-materias">
                Tienes <span>{contadorMateriasSeleccionadas}</span> materias de <span>{maximoDePaquete}</span> permitidas en tu paquete{materiasExtraActuales > 0 ? <> y <span>{materiasExtraActuales}</span> de sobrecarga</> : ''}
            </div>

            {props.planAcademico?.ofertainscrita && props.planAcademico.ofertainscrita.length > 0 && (
                <div className="mt-4">
                    <h6 style={{ color: "#6C757D", marginBottom: "15px" }}>
                        Materias inscritas
                    </h6>
                    {props.planAcademico.ofertainscrita.map((mat, key) => (
                        <MateriaSoloLectura key={`inscrita-${key}`} materia={mat} />
                    ))}
                </div>
            )}
            <div>
                {materiasSeleccionadas.map((x, key) => {
                    return (<Materia key={key} index={key} materia={x} isSelected={key === selectedKey}
                        materiasAlternativas={materiasAlternativas}
                        materiasSeleccionadas={materiasSeleccionadas}
                        onSelect={() => { handleChangeSelectedKey(key) }}
                        onChangeMateria={handleChangeMateria}
                        onBorrarMateria={handleBorrarMateria}
                        planRigido={planRigido}
                    />)
                })}
                {/* Botón para desplegar catálogo de extras */}
                {puedeAgregarMaterias && (
                    <div className="d-grid mt-3">
                        <Button 
                            variant="outline-warning" 
                            style={{ borderColor: "#fd7e14", color: mostrarCatalogoSobrecarga ? "white" : "#fd7e14", backgroundColor: mostrarCatalogoSobrecarga ? "#fd7e14" : "transparent" }}
                            onClick={() => setMostrarCatalogoSobrecarga(!mostrarCatalogoSobrecarga)}>
                            {mostrarCatalogoSobrecarga 
                                ? "Ocultar catálogo de materias" 
                                : (debeAgregarComoSobrecarga ? "Agregar materia de sobrecarga" : "Agregar materia al paquete")
                            }
                        </Button>
                    </div>
                )}

                {mostrarCatalogoSobrecarga && puedeAgregarMaterias && (
                    <Row className="mt-3">
                        <Col md={12}><strong>Materias disponibles para selección:</strong></Col>
                        {materiasDisponiblesParaAgregar.map((mat, k) => (
                            <Col md={12} key={k} className="mt-2">
                                <div className="plantilla container-solid d-flex justify-content-between align-items-center" style={{ borderColor: '#fd7e14', borderWidth: '2px' }}>
                                    <HeaderMateria materia={mat} />
                                    <Button variant="warning" style={{ color: "white" }} onClick={() => handleIntentarAgregarMateria(mat)}>
                                        Añadir
                                    </Button>
                                </div>
                            </Col>
                        ))}
                    </Row>
                )}

                <ModalSobrecarga 
                    show={!!materiaPendienteSobrecarga} 
                    materia={materiaPendienteSobrecarga}
                    onConfirm={confirmarAgregarSobrecarga}
                    onCancel={() => setMateriaPendienteSobrecarga(null)}
                />

                <ModalMinimoSesion 
                    show={!!materiaBloqueadaMinimo} 
                    materia={materiaBloqueadaMinimo}
                    onClose={() => setMateriaBloqueadaMinimo(null)}
                />
            </div>
            
            {hayMateriasCambiadas &&
                <ModalReestablecerPropuesta onReestablecerPropuesta={cargarPropuestaOriginal} />}

            <TerminosCondiciones onChkAceptoTerminosChanged={handleChkAceptoTerminosChanged} />

            <Row className="mb-3 mt-4">
                <Col className="d-grid gap-2">
                    <NotificacionesErrores 
                        insuficiente={cargaMinimaInsuficiente} 
                        conflicto={horarioConflicto}
                        conflictosTipoCurso={conflictosTipoCurso} 
                        costoIndividual={aplicaCostoIndividual}
                    />
                    <Button variant={cumpleTodo ? "primary" : "secondary"} disabled={!cumpleTodo} onClick={handleInscribirMaterias}>Continuar</Button>
                </Col>
            </Row >

            <ContinuarMasTardeButton />
        </div>
    </>)
};

export const HeaderMateria = ({ materia }) => {
    const sesionNum = Number(materia.numsession);
    const modulo = (sesionNum === 1 || sesionNum === 4) ? null : materia.numsessiondescr;
    const formatearFecha = (fechaStr) => {
        if (!fechaStr) return '';
        const partes = fechaStr.split('-');
        if (partes.length === 3) {
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
        return fechaStr;
    };

    const crearFechaSeguro = (valorFecha) => {
        if (!valorFecha) return null;
        const fecha = new Date(valorFecha + "T00:00:00");
        return Number.isNaN(fecha.getTime()) ? null : fecha;
    };

    const obtenerRangoEmpalmeTexto = () => {
        let fechaMin = crearFechaSeguro(materia?.fechainicial);
        let fechaMax = crearFechaSeguro(materia?.fechafinal);

        if (Array.isArray(materia.horario)) {
            materia.horario.forEach(h => {
                const inicio = crearFechaSeguro(h?.fechainicial);
                const fin = crearFechaSeguro(h?.fechafinal);

                if (inicio && (!fechaMin || inicio < fechaMin)) fechaMin = inicio;
                if (fin && (!fechaMax || fin > fechaMax)) fechaMax = fin;
            });
        }

        if (fechaMin && fechaMax) {
            const desde = fechaMin.toISOString().slice(0, 10);
            const hasta = fechaMax.toISOString().slice(0, 10);
            return `Empalme: ${formatearFecha(desde)} al ${formatearFecha(hasta)}`;
        }

        return "Empalme detectado en horario";
    };

    const textoEmpalme = obtenerRangoEmpalmeTexto();

    return (<>
        <div>
            <strong>{materia.descrclase}</strong>
            <div><i>{materia.notaclase}</i></div>
            
            {materia.esEmpalmada && (
                <div className="text-danger small mt-1" style={{ fontWeight: 'bold' }}>
                    <span className="materia-empalmada-indicador">&nbsp;</span>
                    {textoEmpalme}
                </div>
            )}
            
            {materia.hasConflictoTipoCurso && <span className="materia-conflicto-tipocurso-indicador">&nbsp;</span>}
            {materia.errorInscripcion && <>{materia.errorInscripcion}</>}
        </div>
        <div className="horario">
            {modulo && <>{modulo}< br /></>}
            {materia.esVirtual && (materia.virtual !== "N") && 'Virtual'}
            {materia.esVirtual || materia.horario.map((x, key) =>
                <div style={{ textWrapMode: "nowrap" }} key={key}>{x.displayCaption}</div>)}
        </div>
    </>);
};

const ModalSobrecarga = ({ show, materia, onConfirm, onCancel }) => {
    return (
        <Modal show={show} centered backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title style={{ color: "var(--bs-orange, #fd7e14)" }}>
                    <strong>Aviso de Sobrecarga Académica</strong>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Estás a punto de agregar la materia <strong>{materia?.descrclase}</strong> a tu horario original.</p>
                <p>
                    Considera que esto representa una <strong>sobrecarga académica</strong>. Inscribir materias adicionales 
                    puede generar <strong>costos extra en tu colegiatura</strong> y requerirá un <strong>mayor tiempo y carga de estudio</strong> durante el ciclo.
                </p>
                <p>¿Estás completamente seguro de que deseas continuar y agregar esta materia?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>Cancelar</Button>
                <Button variant="warning" onClick={() => onConfirm(materia)} style={{ color: "white", backgroundColor: "#fd7e14", borderColor: "#fd7e14" }}>
                    Sí, agregar sobrecarga
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

const ModalMinimoSesion = ({ show, materia, onClose }) => {
    return (
        <Modal show={show} centered backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title style={{ color: "var(--bs-orange, #fd7e14)" }}>
                    <strong>Aviso de Carga Mínima por Módulo</strong>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>No es posible eliminar la materia <strong>{materia?.descrclase}</strong> de tu selección.</p>
                <p>
                    Debes contar con al menos una materia seleccionada en este módulo/sesión dentro de tu horario para cumplir con la carga académica permitida.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="warning" onClick={onClose} style={{ color: "white", backgroundColor: "#fd7e14", borderColor: "#fd7e14" }}>
                    Entendido
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

const Materia = ({ index, materia, onSelect, isSelected, materiasAlternativas, materiasSeleccionadas, onChangeMateria, onBorrarMateria, planRigido }) => {
    const [showDetalles, setShowDetalles] = useState(null);

    const handleBorrarMateria = () => {
        onBorrarMateria(materia.id);
        startCarousel();
    };


    const HeaderMateriaAlternativa = ({ materiaAlternativa, isDeleted }) => {
        let buttonCaption = isDeleted ? "Agregar" : "Cambiar";
        return (<>
            <div style={{ textAlign: "center" }}>
                <HeaderMateria materia={materiaAlternativa} />
                <Button className="mt-2" variant="link" onClick={() => {
                    setShowDetalles(null);
                    onChangeMateria(materia.id, materiaAlternativa.id)
                }}>{buttonCaption}</Button>
            </div>
        </>);
    };

    const ListaMateriasAlternativas = ({ materiaOrig, materiasAlternativas, isDeleted, materiasSeleccionadas }) => {
        const { tipoCursos } = useValidadorTipoCurso(materiasSeleccionadas);

        if (!materiasAlternativas || !materiasAlternativas.length) return null;

        let data = JSON.parse(JSON.stringify(materiasSeleccionadas));
        data = data.filter(x => !x.esVirtual);
        data = data.sort((a, b) => { return a.numsession - b.numsession; });
        let materiasSeleccionadasIds = materiasSeleccionadas.filter(x => !x.deleted).map(x => x.idmateria);
        materiasAlternativas = materiasAlternativas.filter(x => !materiasSeleccionadasIds.includes(x.idmateria));

        //filtrar por session
        materiasAlternativas = materiasAlternativas.filter(x => x.numsession === materiaOrig.numsession);

        //filtrar por tipo curso
        materiasAlternativas = materiasAlternativas.filter(x => x.maximotipocurso !== -1);
        tipoCursos.filter(x => x.maximotipocurso > 0)
            .forEach(tipoCurso => {
                if (tipoCurso.total >= tipoCurso.maximotipocurso) {
                    materiasAlternativas = materiasAlternativas.filter(x => x.tipocurso !== tipoCurso.tipocurso);
                }
            });

        if (!materiasAlternativas || !materiasAlternativas.length) return null;

        materiasAlternativas
            .forEach(matAlternativa => {
                if (matAlternativa.esVirtual) return;
                let materiasSesion = data.filter(x => x.numsession === matAlternativa.numsession);
                matAlternativa.esEmpalmada = false;
                let empalma = materiasSesion.filter(x => x.id !== materia.id).some(m => {
                    return ofertaAcademicaClass.seEmpalmaMateria(matAlternativa, m)
                });

                matAlternativa.esEmpalmada = empalma;
            });

        //materiasAlternativas = materiasAlternativas.filter(x => !x.esEmpalmada);
        //if (!materiasAlternativas || !materiasAlternativas.length) return null;

        return (<>
            <Row className="mt-3">
                <Col>
                    {!isDeleted && (<><strong>Cambia la clase actual</strong> por otra de las siguientes:</>)}
                    {isDeleted && (<><strong>Selecciona la clase que deseas agregar</strong> a tu calendario:</>)}
                </Col>
            </Row>
            <Row>
                <div id={`main-gallery-${index}`} className="main-gallery js-flickity" >
                    {materiasAlternativas.map((materiaAlternativa, key) => {
                        return (
                            <div key={key} className="gallery-cell">
                                <div className="plantilla container-solid">
                                    <HeaderMateriaAlternativa materiaAlternativa={materiaAlternativa}
                                        isDeleted={isDeleted} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Row>
        </>);
    };

    const ListaHorariosAlternos = ({ mismaMateriaHorariosAlternos }) => {
        if (!mismaMateriaHorariosAlternos || !mismaMateriaHorariosAlternos.length) return null;

        return (<>
            <Row className="mt-3">
                <Col>
                    <strong>Selecciona otro horario</strong>
                </Col>
            </Row>
            <Row className="d-grid" style={{ padding: "10px" }}>
                {mismaMateriaHorariosAlternos.map((altMat, key) => {
                    return <div key={key} className="horario alterno"
                        onClick={() => {
                            setShowDetalles(null);
                            onChangeMateria(materia.id, altMat.id)
                        }}>
                        {altMat.horario.map(h => h.displayCaption)}
                        <span className="material-symbols-outlined">
                            chevron_right
                        </span>
                    </div>;
                })}
            </Row>
        </>);
    };


    const startCarousel = () => {
        var el = document.getElementById(`main-gallery-${index}`);
        if (!el) return;

        if (el.carouselLoaded) return;
        el.carouselLoaded = "carouselLoaded";

        new window.Flickity(`#main-gallery-${index}`, {
            // options
            cellAlign: 'center',
            //contain: true,
            //wrapAround: true 
        });
    };

    useEffect(() => {
        if (showDetalles != null) onSelect();
    }, [showDetalles])

    useEffect(() => {
        startCarousel();

        if (!isSelected) setShowDetalles(null);
    }, [isSelected])

    useEffect(() => {
        startCarousel();
    })

    startCarousel();

    if (materia.deleted) {
        return <>
            <div key={index} className="plantilla container-solid seleccion-horarios">
                <div className="d-grid">
                    <Button variant="link"
                        onClick={() => { setShowDetalles(true) }}
                        style={{
                            alignItems: "center",
                            display: "inline-flex",
                            textDecoration: "none",
                            justifyContent: "center",
                            height: "auto",
                            border: "none",
                            color: "var(--black) !important",
                        }}>
                        <span style={{ margin: "10px" }}>Agregar una clase</span>
                        <span className="material-symbols-outlined">add_circle</span>
                    </Button>
                </div>

                {showDetalles && <>
                    <ListaMateriasAlternativas
                        materiaOrig={materia}
                        materiasAlternativas={materiasAlternativas}
                        isDeleted={!!materia.deleted}
                        materiasSeleccionadas={materiasSeleccionadas}
                    />
                </>}
            </div>
        </>
    }

    const getMismaMateriaHorariosAlternos = () => {
        var data = materiasAlternativas.filter(m => m.idmateria === materia.idmateria);
        return data;
    };

    return (<>
        <div key={index} className="plantilla container-solid seleccion-horarios"
            style={{ borderColor: materia.esExtra ? '#fd7e14' : (materia.cambiada ? 'green' : "#DFDFDF"), borderWidth: materia.esExtra ? '2px' : '1px' }}>
            <div className="horario main">
                <div className="col-xs-auto">
                    <HeaderMateria materia={materia} />
                    {materia.cambiada && !materia.esExtra && <Badge bg="success">Cambiada</Badge>}
                    {materia.esExtra && <Badge bg="warning" text="dark" style={{ backgroundColor: "#fd7e14", color: "white" }}>Sobrecarga</Badge>}
                </div>
                <div className="col-xs-auto" style={{ display: "flex" }}>
                    {showDetalles && <ModalDeleteMateria onDeleteMateria={handleBorrarMateria} />}

                    <Button variant="link" size="sm"
                        style={{
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center"
                        }}
                        onClick={() => { setShowDetalles(!showDetalles) }}>
                        {showDetalles && <span className="material-symbols-outlined">keyboard_arrow_up</span>}
                        {showDetalles || <span className="material-symbols-outlined">keyboard_arrow_down</span>}
                    </Button>
                </div>
            </div>

            {isSelected && (<>
                <ListaHorariosAlternos mismaMateriaHorariosAlternos={getMismaMateriaHorariosAlternos()} />

                <ListaMateriasAlternativas
                    materiaOrig={materia}
                    materiasAlternativas={materiasAlternativas}
                    materiasSeleccionadas={materiasSeleccionadas} />
            </>)}

        </div>
    </>);
};


const TerminosCondiciones = ({ onChkAceptoTerminosChanged }) => {
    const handleChange = (event) => {
        onChkAceptoTerminosChanged(event.target.checked);
    };
    return (<>
        <div className="mt-4">
            <strong>Para continuar acepta términos</strong>

            <div className="container mt-3" >
                <div className="mb-3">
                    <Form.Check
                        type="checkbox"
                        id={`chkAceptoTerminos`}
                        label={`Acepto términos y condiciones`}
                        className="terminos-condiciones checkbox"
                        onClick={handleChange}
                    />
                </div>

                <div className="d-grid">
                    <ModalTerminosCondiciones />
                </div>
            </div>
        </div>

    </>)
};

const ModalTerminosCondiciones = () => {
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);

    return (<>
        <Button variant="link" onClick={() => { setShowModal(true) }}>Leer términos y condiciones</Button>

        <Modal size="lg" show={showModal} onHide={handleClose} >
            <Modal.Header closeButton>
                <Modal.Title><strong>Terminos y condiciones</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Plantilla id="TerminosCondiciones"></Plantilla>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Row style={{ display: "contents" }}>
                    <Col className="d-grid gap-2" >
                        <Button variant="primary" onClick={handleClose}>
                            Aceptar
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    </>);

};

const ModalReestablecerPropuesta = ({ onReestablecerPropuesta }) => {
    const [showModal, setShowModal] = useState(false);
    const closeModal = () => { setShowModal(false) };
    const handleReestablecerPropuesta = () => {
        closeModal();
        onReestablecerPropuesta();
    };

    return (<>
        <div className="d-grid mt-3" >
            <Button variant="link" onClick={() => { setShowModal(true); }} style={{
                alignItems: "center",
                display: "inline-flex",
                textDecoration: "none",
                justifyContent: "center",
                height: "auto",
            }}>
                <span style={{ margin: "10px", textDecoration: "underline" }}>Regresar a propuesta original</span>
                <span className="material-symbols-outlined">undo</span>
            </Button>

        </div>

        <Modal size="lg" show={showModal} animation={false} style={{ height: "auto" }}>
            <Modal.Body>
                <Row>
                    <Plantilla id="ReestablecerPropuestaOriginal"/>
                </Row>
            </Modal.Body>
            <Modal.Footer className="portal">
                <Row className="mb-2 mt-3" style={{ width: "100%" }}>
                    <Col className="d-grid gap-2">
                        <Button variant="primary bg-color-red" onClick={closeModal}>
                            Continuar con mi horario
                        </Button>
                    </Col>
                </Row>
                <Row className="mb-3 mt-3" style={{ width: "100%" }}>
                    <Col className="d-grid gap-2">
                        <Button variant="primary" onClick={handleReestablecerPropuesta}>
                            Regresar a propuesta original
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
        
    </>);
};

const ModalDeleteMateria= ({ onDeleteMateria}) => {
    const [showModal, setShowModal] = useState(false);
    const closeModal = () => { setShowModal(false) };
    const handleDeleteMateria = () => {
        closeModal();
        onDeleteMateria();
    };

    return (<>
        <Button variant="link" size="sm" onClick={() => { setShowModal(true) }}
            style={{ textDecoration: "none", marginRight: "10px", paddingTop: "10px" }} >
            <span className="material-symbols-outlined">delete</span>
        </Button>

        <Modal show={showModal} centered style={{ height: "auto" }}>
            <Modal.Body>
                <div className="container portal">
                    <h5>Confirma</h5>

                    <Row className="mb-3 mt-4">
                        <Col className="d-grid gap-2">
                            ¿Estas seguro de querer borrar la materia?
                        </Col>
                    </Row>

                    <Row className="mb-3 mt-4">
                        <Col className="d-grid gap-2">
                            <Button variant="primary" onClick={closeModal}>
                                Cancelar
                            </Button>
                        </Col>
                    </Row>
                    <Row className=" mt-4">
                        <Col className="d-grid gap-2">
                            <Button variant="primary bg-color-red" onClick={handleDeleteMateria}>
                                Borrar materia
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    </>);
};

const ModalClaseSinCupo = ({ show, onContinuarConHorario, onReestablecerPropuesta }) => {
    const handleReestablecerPropuesta = () => {
        onReestablecerPropuesta();
    };

    return (<>
        <Modal show={!!show} centered style={{ height: "auto" }}>
            <Modal.Body>
                <div className="container portal">
                    <Plantilla id="ClaseSinCupo" />

                    <Row className="mb-3 mt-4">
                        <Col className="d-grid gap-2">
                            <Button variant="primary" onClick={onContinuarConHorario}>
                                Continuar con mi horario
                            </Button>
                        </Col>
                    </Row>
                    <Row className=" mt-4">
                        <Col className="d-grid gap-2">
                            <Button variant="primary bg-color-red" onClick={handleReestablecerPropuesta}>
                                Regresar a propuesta original
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    </>);
};

const MateriaSoloLectura = ({ materia }) => {
    const sesionNum = Number(materia.numsession);
    const modulo = (sesionNum === 1 || sesionNum === 4) ? null : materia.numsessiondescr;
    const obtenerLineasHorario = (h) => {
        if (h.displayCaption) return [h.displayCaption];

        const mapDias = { "L": "Lun", "M": "Mar", "MI": "Mie", "J": "Jue", "V": "Vie", "S": "Sab", "D": "Dom" };
        
        const formatearHora = (hora24) => {
            if (!hora24) return "00:00";
            let [horas, min] = hora24.split(':');
            let hrs = parseInt(horas, 10);
            hrs = hrs % 12 || 12; 
            return `${hrs < 10 ? '0' + hrs : hrs}:${min}`;
        };

        const diasRaw = h.dia ? h.dia.split(',').map(d => d.trim()) : [];
        const inicio = formatearHora(h.horainicio);
        const fin = formatearHora(h.horafin);

        return diasRaw.map(d => `${mapDias[d] || d}: ${inicio} - ${fin}`);
    };

    return (
        <div className="plantilla container-solid seleccion-horarios mb-2" 
             style={{ 
                 backgroundColor: "#F5F5F5",
                 borderColor: "#E0E0E0",
                 color: "#6C757D",
                 pointerEvents: "none"
             }}>
            <div className="horario main">
                <div className="col-xs-auto" style={{ opacity: 0.85 }}>
                    <div>
                        <strong>{materia.descrclase}</strong>
                        {materia.notaclase && <div><i>{materia.notaclase}</i></div>}
                    </div>
                    
                    <div className="horario mt-1">
                        {modulo && <>{modulo}< br /></>}
                        
                        {materia.esVirtual && (materia.virtual !== "N") ? (
                            <div>Virtual</div>
                        ) : (
                            materia.horario && Array.isArray(materia.horario) && materia.horario.length > 0 && (
                                materia.horario.map((x, key) => {
                                    const lineas = obtenerLineasHorario(x);
                                    return (
                                        <React.Fragment key={key}>
                                            {lineas.map((linea, index) => (
                                                <div style={{ textWrapMode: "nowrap" }} key={`${key}-${index}`}>
                                                    {linea}
                                                </div>
                                            ))}
                                        </React.Fragment>
                                    )
                                })
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SeleccionHorario;